import RegistrationValidateEmail from "../components/RegistrationValidateEmail";
import { connect } from "react-redux";
import { actions } from "../reducers/registration";
import { withRouter } from "react-router";

export default withRouter(
  connect(
    (state) => ({
      validateEmailResult: state.registration.validateEmailStatus.valid,
      validateEmailProcessing: state.registration.validateEmailStatus.isLoading,
      validateEmailError: state.registration.validateEmailStatus.error,
      validateEmailCode: state.registration.validateEmailStatus.code,
      validateEmailUserRole: state.registration.validateEmailStatus.role,
    }),
    // Inject all actions into the component (as props)
    actions
  )(RegistrationValidateEmail)
);
